import React from 'react';

const IFrameViewer = () => {
    return (<iframe id="iframeHtml" style={{ height: '412px' }}></iframe>)
}

export default IFrameViewer;
